module.exports = __webpack_public_path__ + "static/media/popcorn.9695562f.png";